import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ShopProductsList } from '@/app/[locale]/shop/[username]/(shop)/components/ProductList';
import { SoldProductsEmptyState } from '@/app/[locale]/shop/[username]/(shop)/components/SoldProductsEmptyState';

type Props = Pick<
  React.ComponentProps<typeof ShopProductsList>,
  | 'products'
  | 'hasMore'
  | 'isFetchingNextPage'
  | 'onEndReached'
  | 'isError'
  | 'isLoading'
>;

export function SoldProducts({
  products,
  hasMore,
  isFetchingNextPage,
  onEndReached,
  isError,
  isLoading,
}: Props) {
  const tShop = useTranslations('shop');

  return (
    <section>
      <Body variant="sm-bold" className={styles.headingText}>
        {tShop('SoldItems')}
      </Body>
      <ShopProductsList
        hasMore={hasMore}
        isFetchingNextPage={isFetchingNextPage}
        products={products}
        onEndReached={onEndReached}
        isLoading={isLoading}
        isError={isError}
        EmptyState={() => <SoldProductsEmptyState />}
      />
    </section>
  );
}
